<template>
  <div>
    <vxe-grid
      ref="vxeGrid"
      auto-resize
      highlight-hover-row
      :toolbar-config="tableToolbar"
      :data="tableData"
      :columns="tableColumns"
      :loading="loading"
      :height="tableHeight - 6"
      size="small"
      :expand-config="{ reserve: true }"
      resizable
      border
      show-footer
      :footer-method="() => footerData"
    >
      <template v-slot:toolbar_form>
        <slot name="header"></slot>
      </template>
      <template v-slot:expandContent="{ row }">
        <GoodsTable class="m-2" :orderBatchCode="row.orderBatchCode" />
      </template>
      <template v-slot:opt="{ row }">
        <div>
          <el-tooltip
            class="item"
            effect="dark"
            :content="$l('INDEX.btn_tips_view') || 查看"
            placement="top"
          >
            <i
              class="el-icon-view tool-btn"
              @click="$emit('openDetailDialog', row)"
            ></i>
          </el-tooltip>
        </div>
      </template>
      <template v-slot:empty>
        <div style="text-align: center">
          <img src="/image/static/img/nodata.png" />
          <p class="no-data">{{ $l('INDEX.tips_no_data') || '暂无数据！' }}</p>
        </div>
      </template>
    </vxe-grid>
  </div>
</template>
<script>
import tableColumns from './table-columns'
import TableAutoHeight from '@/mixins/table-auto-height'
import GoodsTable from '../goods-table'
import { add } from '@/libs/util.number.js'
export default {
  mixins: [TableAutoHeight],
  components: { GoodsTable },
  props: {
    tableData: { type: Array, default: () => [] },
    loading: { type: Boolean, default: false },
  },
  computed: {
    footerData() {
      if (!this.tableData) return 0
      let totQty = 0
      let totBoxQty = 0

      this.tableData.forEach(
        (i) => (
          (totQty = add(totQty, i.totQty)),
          (totBoxQty = add(totBoxQty, i.totBoxQty))
        )
      )
      return [
        [
          this.$l('INDEX.total') || '合计',
          '',
          '',
          '',
          '',
          '',
          '',
          '',
          '',
          '',
          totQty,
          totBoxQty,
        ],
      ]
    },
  },
  data() {
    return {
      tableToolbar: {
        slots: {
          buttons: 'toolbar_form',
        },
        refresh: {
          query: () => this.$emit('reload'),
        },
        zoom: true,
      },
      tableColumns: tableColumns(this),
    }
  },
}
</script>
